import { isAfter } from '../../util/date';
import { resolveAllotmentPeriodForCrd } from './compAllotmentByPeriod';

export const toCustomerRequestDateString = crd => (crd ? crd.split('T')[0] : null);

export const getTodayDateString = () => new Date().toISOString().split('T')[0];

export const isSelectableCustomerRequestDate = (
  crd,
  { currentAllotment, futureAllotment, orderType, today = getTodayDateString() } = {}
) => {
  const date = toCustomerRequestDateString(crd);

  if (!date) {
    return false;
  }

  if (!isAfter({ start: today, date, inclusive: true })) {
    return false;
  }

  return resolveAllotmentPeriodForCrd(date, currentAllotment, futureAllotment, orderType) !== 'none';
};

export const filterCustomerRequestDates = (
  customerRequestDates = [],
  { currentAllotment, futureAllotment, orderType, today } = {}
) =>
  customerRequestDates.filter(crd =>
    isSelectableCustomerRequestDate(crd, { currentAllotment, futureAllotment, orderType, today })
  );

export const findMatchingCustomerRequestDate = (selectedDate, customerRequestDates = []) =>
  customerRequestDates.find(crd => toCustomerRequestDateString(crd) === toCustomerRequestDateString(selectedDate));
